export default __webpack_public_path__ + "static/media/Color-Trial.325fb46a.png";